import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { confi } from "../assets/index";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { SlLogin } from "react-icons/sl";
import { GoogleLogo } from "./logo";
import PrivacyPolicy from "./PrivacyPolicy";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";

const Login = ({ onLogin }) => {
  const [email, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isPPVisble, setPrivacyPolicyVisible] = useState(false);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [step, setStep] = useState(1);
  const [inputOtp, setInputOtp] = useState();

  const [isLoading, setIsLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  // States for Forgot Password
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState(false); // Tracks success screen in modal

  // --- COMMENTED OUT: Change Password States ---
  // const [showChangeModal, setShowChangeModal] = useState(false);
  // const [changeEmail, setChangeEmail] = useState("");
  // const [currentPassword, setCurrentPassword] = useState("");
  // const [newPassword, setNewPassword] = useState("");

  const verifyOtp = (e) => {
    e.preventDefault();
    axios
      .post("https://api.confidanto.com/signup/verify-otp", {
        email: localStorage.getItem("email"),
        otp: inputOtp,
      })
      .then((res) => {
        setStep(1);
        alert("Otp Verified");
      })
      .catch((err) => {
        alert("Invalid Otp");
      });
  };

  const resendOtp = (e) => {
    e.preventDefault();
    axios
      .post("https://api.confidanto.com/signup/resend-otp", {
        email: localStorage.getItem("email"),
      })
      .then((res) => {
        alert("Otp Sent. Please check email.");
      })
      .catch((err) => {
        alert("Wait 2 minutes to Resend Otp.");
      });
  };

  const clientId =
    "659080974027-0admdhavffv1454brkqljuekim654ihl.apps.googleusercontent.com";
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("https://api.confidanto.com/login", { email, password })
      .then((res) => {
        if (res.data) {
          const { token } = res.data;
          const { email } = res.data.user;

          localStorage.setItem("token", token);
          localStorage.setItem("email", email);

          axios
            .post("https://api.confidanto.com/user/check-email-verification", {
              email: email,
            })
            .then((res) => {
              if (res.data.verify_status) {
                onLogin(email);
              } else {
                alert("Email not verified");
              }
            })
            .catch((err) => {});
        } else {
          alert("Failed to login");
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          alert("Invalid username or password");
        } else {
          alert(error?.response?.data);
        }
      });
  };

  // --- Forgot Password Flow ---
  const handleForgotPassword = (e) => {
    e.preventDefault();
    setIsLoading(true);
    axios
      .post("https://api.confidanto.com/update-profile/forgot-password", {
        email: forgotEmail,
      })
      .then((res) => {
        setIsLoading(false);
        // Switch modal view to success message
        setForgotPasswordSuccess(true);
      })
      .catch((err) => {
        setIsLoading(false);
        alert(
          err?.response?.data?.message ||
            "Email not found / Failed to send OTP",
        );
        closeForgotModal(); // Close modal completely if it fails
      });
  };

  const closeForgotModal = () => {
    setShowForgotModal(false);
    setForgotEmail("");
    setForgotPasswordSuccess(false);
  };

  // --- COMMENTED OUT: Change Password Flow ---
  // const handleChangePassword = (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   axios
  //     .post("https://api.confidanto.com/update-profile/change-password", {
  //       email: changeEmail,
  //       currentPassword: currentPassword,
  //       newPassword: newPassword,
  //     })
  //     .then((res) => {
  //       setIsLoading(false);
  //       alert(res.data.message || "Password changed successfully");
  //       setShowChangeModal(false);
  //       setChangeEmail("");
  //       setCurrentPassword("");
  //       setNewPassword("");
  //     })
  //     .catch((err) => {
  //       setIsLoading(false);
  //       alert(err?.response?.data?.message || "Failed to change password");
  //     });
  // };

  const passwordTooltip =
    "Must have at least 6 characters.<br>----------------------------------------------------------- <br>Its better to have: <br>1. Upper & Lower case letters <br>2. A special character <br>3. A longer password";

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const login = useGoogleLogin({
    clientId,
    onSuccess: async (tokenResponse) => {
      setIsLoading(true);

      setToken(tokenResponse.access_token);

      const userInfo = await axios.get(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        { headers: { Authorization: `Bearer ${tokenResponse.access_token}` } },
      );
      console.log("User Info:", userInfo.data);

      const res = await axios.post(
        "https://api.confidanto.com/continue-with-google/check",
        {
          userName: userInfo.data.name,
          email: userInfo.data.email,
          token: tokenResponse.access_token,
        },
      );

      if (res.data.message === true) {
        localStorage.setItem("token", tokenResponse.access_token);
        localStorage.setItem("email", userInfo.data.email);
        onLogin(email);
        return;
      } else {
        setTimeout(() => {
          setIsLoading(false);
          setShowErrorModal(true);
        }, 1500);
      }
    },
    onError: (error) => {},
  });

  return (
    <>
      <style>
        {`
          body {
            overflow-y: hidden;
            font-family: "Calibri", sans-serif;
          }
        `}
      </style>

      <div className="bg-white md:overflow-auto sm:overflow-y-scroll font-roboto relative">
        <a href="https://www.confidanto.com" rel="noopener noreferrer">
          <img
            src={confi}
            alt="Logo"
            className="h-6 w-32 lg:h-12 lg:w-auto mb-6 mt-8 ml-8"
            style={{ width: "234px", height: "46px" }}
          />
        </a>
        <div className="min-h-screen flex justify-center bg-cover bg-center bg-transparent w-full">
          <div className="max-w-4xl bg-white bg-opacity-75 rounded-lg p-8">
            <h2 className="mt-6 text-center text-4xl lg:text-6xl font-bold text-gray-900">
              Log In
            </h2>
            <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
              <div className="flex flex-wrap w-full justify-between items-center">
                {step == 1 ? (
                  <div className="w-full lg:w-64 mx-4 items-center">
                    <div className="relative">
                      <input
                        id="username"
                        name="username"
                        type="text"
                        autoComplete="username"
                        required
                        className="block px-2.5 pb-2.5 pt-5 w-full text-sm lg:text-base text-gray-900 bg-transparent dark:bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        placeholder=""
                        value={email}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                      <label
                        htmlFor="username"
                        className="absolute text-sm lg:text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
                      >
                        Email
                      </label>
                    </div>

                    <div className="relative top-4">
                      <input
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        autoComplete="current-password"
                        required
                        className="block px-2.5 pb-2.5 pt-5 w-full text-sm lg:text-base text-gray-900 bg-transparent dark:bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        placeholder=""
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <label
                        htmlFor="password"
                        className="absolute text-sm lg:text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
                      >
                        Password
                      </label>
                      <button
                        type="button"
                        className="absolute top-6 right-4 focus:outline-none text-xl"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                      </button>
                    </div>

                    {/* Forgot Password Link - Moved to the Left (justify-start) */}
                    {false && (
                      <div className="flex justify-start mt-6 -mb-6">
                        <button
                          type="button"
                          onClick={() => {
                            setShowForgotModal(true);
                            setForgotPasswordSuccess(false);
                          }}
                          className="font-medium text-sm text-indigo-600 hover:text-indigo-500 focus:outline-none"
                        >
                          Forgot Password?
                        </button>
                      </div>
                    )}

                    <div className="mt-12">
                      <button
                        type="submit"
                        className="group relative w-full lg:w-10/12 text-[#0f62e6] items-center flex justify-center py-2 px-4 border border-[#0f62e6] text-sm lg:text-base font-medium rounded-full hover:text-white bg-transparent hover:bg-[#0f62e6] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        Login
                        <span className="ml-4">
                          <SlLogin />
                        </span>
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className=" space-y-4">
                      <div>
                        <h4 className="ml-2">
                          Email Sent to: {localStorage.getItem("email")}
                        </h4>
                        <input
                          id="otp"
                          name="otp"
                          type="number"
                          autoComplete="otp"
                          required
                          className="block px-4 py-3 w-full text-inherit text-gray-900 bg-transparent border-b-2 border-gray-300 appearance-none focus:outline-none focus:border-blue-600 peer"
                          placeholder="Enter Otp"
                          value={inputOtp}
                          onChange={(e) => {
                            setInputOtp(e.currentTarget.value);
                          }}
                        />
                        <div className="flex justify-between items-center mt-2">
                          <button
                            className="p-2 bg-blue-500 rounded-md font-roboto text-white hover:text-blue-500 hover:bg-white border-2 border-white hover:border-blue-500"
                            onClick={verifyOtp}
                          >
                            Verify Otp
                          </button>
                          <button
                            className="p-2 bg-blue-500 rounded-md font-roboto text-white hover:text-blue-500 hover:bg-white border-2 border-white hover:border-blue-500"
                            onClick={resendOtp}
                          >
                            Resend Otp
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="flex lg:flex-col items-center justify-center w-full lg:w-auto py-6 lg:py-0 opacity-80 px-7 poster:lg:mx-6">
                  <div className="flex-1 h-[1px] w-full lg:w-[1px] lg:min-h-[150px] bg-gray-300"></div>

                  <p className="px-4 lg:px-0 lg:py-6 mb-0 text-center font-bold text-gray-400 uppercase text-xs tracking-wider">
                    or
                  </p>

                  <div className="flex-1 h-[1px] w-full lg:w-[1px] lg:min-h-[150px] bg-gray-300"></div>
                </div>

                <div className="flex lg:flex-col items-center justify-center w-full lg:w-auto mt-2 lg:mt-0 space-y-4 lg:space-y-2 lg:space-x-4">
                  <div className="google-btn w-full lg:w-fit h-10 bg-blue-500 hover:shadow-xl relative hover:shadow-outline active:bg-blue-600 mt-2">
                    <button
                      className="google-btn w-full lg:w-[350px] h-10 bg-blue-500 shadow-md relative hover:shadow-outline active:bg-blue-600"
                      type="button"
                      onClick={login}
                    >
                      <div className="flex items-center border-1 border-blue-600">
                        <div className="google-icon-wrapper w-10 h-10 bg-white relative">
                          <img
                            className="google-icon w-6 h-6 absolute top-2 left-1.5"
                            src={GoogleLogo}
                            alt="Google Icon"
                          />
                        </div>
                        <p className="btn-text font-semibold text-white text-sm lg:text-base leading-none w-full lg:px-12">
                          Continue with Google
                        </p>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div className="flex items-center justify-center text-xs text-gray-500 mt-4">
              <p className="px-1 text-center">Terms of Use</p>
              <button
                onClick={(e) => setPrivacyPolicyVisible(true)}
                className="px-1 text-center"
              >
                Privacy Policy
              </button>
            </div>
            <div className="flex items-center justify-center text-xs text-gray-500 mt-2">
              <p className="px-4 text-center">
                Policy and Terms of Service apply.
              </p>
            </div>
          </div>
        </div>

        {/* Global Loader - Increased z-index to [60] so it overlays the modals */}
        {isLoading && (
          <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-70 backdrop-blur-sm z-[60]">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
          </div>
        )}

        {/* Forgot Password Modal */}
        {showForgotModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl p-6 md:p-8 max-w-md w-full flex flex-col space-y-4">
              {!forgotPasswordSuccess ? (
                <>
                  <h3 className="text-2xl font-bold text-gray-900 tracking-tight">
                    Forgot Password
                  </h3>
                  <p className="text-sm text-gray-500">
                    Enter your email address to receive a verification OTP.
                  </p>
                  <form onSubmit={handleForgotPassword} className="space-y-4">
                    <div>
                      <input
                        type="email"
                        required
                        className="block px-4 py-3 w-full text-sm text-gray-900 bg-transparent border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                        placeholder="Email Address"
                        value={forgotEmail}
                        onChange={(e) => setForgotEmail(e.target.value)}
                      />
                    </div>
                    <div className="flex justify-end space-x-3 mt-4">
                      <button
                        type="button"
                        onClick={closeForgotModal}
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50"
                        disabled={isLoading}
                      >
                        Send OTP
                      </button>
                    </div>
                  </form>
                </>
              ) : (
                <div className="text-center py-4">
                  {/* Success Checkmark Icon */}
                  <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
                    <svg
                      className="h-8 w-8 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 tracking-tight mb-2">
                    Success
                  </h3>
                  <p className="text-sm text-gray-500 mb-8">
                    An OTP has been successfully sent to{" "}
                    <span className="font-semibold text-gray-800">
                      {forgotEmail}
                    </span>
                    . Please check your inbox.
                  </p>
                  <button
                    type="button"
                    onClick={closeForgotModal}
                    className="w-full px-4 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                  >
                    Close
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* --- COMMENTED OUT: Change Password Modal --- */}
        {/* {showChangeModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl p-6 md:p-8 max-w-md w-full flex flex-col space-y-4">
              <h3 className="text-2xl font-bold text-gray-900 tracking-tight">Change Password</h3>
              <p className="text-sm text-gray-500">Update your account password using your current password or OTP.</p>
              <form onSubmit={handleChangePassword} className="space-y-4">
                <div>
                  <input 
                    type="email" 
                    required 
                    className="block px-4 py-2.5 w-full text-sm text-gray-900 bg-transparent border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 mb-3" 
                    placeholder="Email Address" 
                    value={changeEmail} 
                    onChange={(e) => setChangeEmail(e.target.value)} 
                  />
                  <input 
                    type="password" 
                    required 
                    className="block px-4 py-2.5 w-full text-sm text-gray-900 bg-transparent border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 mb-3" 
                    placeholder="Current Password / OTP" 
                    value={currentPassword} 
                    onChange={(e) => setCurrentPassword(e.target.value)} 
                  />
                  <input 
                    type="password" 
                    required 
                    className="block px-4 py-2.5 w-full text-sm text-gray-900 bg-transparent border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600" 
                    placeholder="New Password" 
                    value={newPassword} 
                    onChange={(e) => setNewPassword(e.target.value)} 
                  />
                </div>
                <div className="flex justify-end space-x-3 mt-4">
                  <button 
                    type="button" 
                    onClick={() => setShowChangeModal(false)} 
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50"
                    disabled={isLoading}
                  >
                    Change Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        )} */}

        {showErrorModal && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50 transition-opacity p-4"
            onClick={() => setShowErrorModal(false)}
          >
            <div
              className="bg-white rounded-xl shadow-2xl p-6 md:p-8 max-w-[550px] w-full flex items-start space-x-5 transform transition-all"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex-shrink-0 mt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#f59e0b"
                  className="w-8 h-8"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a1 1 0 100-2 1 1 0 000 2z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="flex flex-col space-y-4">
                <h3 className="text-xl font-bold text-gray-900 tracking-tight">
                  Sorry, we couldn't log you in.
                </h3>
                <p className="text-gray-600 text-[15px] leading-relaxed">
                  Some policies were not met. Access Denied: Your user must be
                  invited first. To fix this please make sure you are able to
                  login through the UI.
                </p>
                <button
                  onClick={() => setShowErrorModal(false)}
                  className="text-blue-600 font-semibold text-left hover:text-blue-800 transition-colors w-fit p-0 m-0 border-none bg-transparent underline underline-offset-4"
                >
                  Return to the login page
                </button>
                <div className="pt-2 mt-2 border-t border-gray-100">
                  <p className="text-sm text-gray-500 leading-relaxed pt-2">
                    If you're still experiencing issues, please contact your
                    local administrator or Client Success Manager.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {isPPVisble && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-8">
            <div className="bg-white rounded-lg w-3/6 relative">
              <PrivacyPolicy onClose={() => setPrivacyPolicyVisible(false)} />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default Login;
